import request from '@/api/request';

/**
 * 模型测试相关的API接口
 */
export const speakApi = {
    /**
     * 获取测试批次列表
     */
    getBatches() {
        return request({
            url: '/api/model-test/batches',
            method: 'get'
        });
    },

    /**
     * 获取测试历史记录
     */
    getHistory(params) {
        return request({
            url: '/api/model-test/history',
            method: 'get',
            params
        });
    },


    /**
     * 导出Excel
     */
    exportExcel(params) {
        return request({
            url: '/api/page/model-test/export',
            method: 'get',
            params,
            responseType: 'blob'
        });
    }
};
